<template>
  <div
    :class="
      'button-property-1-secondary-hover-false ' +
      'property-1-' +
      property1 +
      ' hover-' +
      hover
    "
  >
    <div class="login">{{ $t("sign-up") }}</div>
  </div>
</template>
<script>
export default {
  name: "ButtonProperty1SecondaryHoverFalse",
  components: {},
  props: {
    property1: {
      type: String,
      default: "primary",
    },
    hover: {
      type: String,
      default: "false",
    },
  },
};
</script>
<style scoped>
.button-property-1-secondary-hover-false,
.button-property-1-secondary-hover-false * {
  box-sizing: border-box;
}
.button-property-1-secondary-hover-false {
  background: #E0F5FF;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: 150px;
  position: relative;
}
.login {
  color: #1a1a1a;
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-weight: 500;
  position: relative;
  flex: 1;
}

@media only screen and (min-width: 1023px) and (max-width: 1220px) {
  .button-property-1-secondary-hover-false {
    border-width: 1.5px;
    align-self: normal;
    min-width: 110px;
  }
  /* .login {
    font-size: 14px;
  } */
}
</style>
